import { Box, CircularProgress } from '@mui/material';
import React from 'react';

interface MyFilterSectionFallbackProps {
  expand: boolean;
}

export const MyFilterSectionFallback = (
  props: MyFilterSectionFallbackProps
) => {
  const { expand } = props;
  return expand ? (
    <Box sx={{ display: 'flex' }}>
      <CircularProgress size={20} color="warning" />
    </Box>
  ) : null;
};
